import { GetSessionToken } from "./store";

export function validateEmail(email: string) {
  if (email.trim().length === 0) {
    return false;
  }
  const emailFilter = new RegExp(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g);
  return emailFilter.test(email);
}

export function validateLoginStatus() {
  try {
    const sessionToken = GetSessionToken();
    return !!sessionToken;
  } catch (e) {
    return false;
  }
}
